module.exports = __webpack_public_path__ + "static/media/5s.e64a4def.png";